module.exports = __webpack_public_path__ + "img/whats-new-16_en.cda70bf.jpg";